import { has, isNil } from 'lodash-es'
import { apiRequest, handleCall } from 'syft-acp-core/api/call'

/**
 * Fetches File from API and downloads in the same tab.
 * Used to track such downloads in DataDog
 *
 * @param path
 * @param reqArgs
 * @param fallbackName
 * @returns {Promise<unknown>}
 */
export const downloadAsFileFromApi = (path, reqArgs, fallbackName = 'result') =>
  new Promise((resolve, reject) => {
    const returnAll = !has(reqArgs, 'per_page') || isNil(reqArgs.per_page)
    const req = apiRequest({ path, reqArgs, returnAll, method: reqArgs.method })
    // The function loads a CSV as a readable stream for file downloads.
    // Always use isStream = true for file downloads regardless of HTTP method
    handleCall(req, resolve, reject, true, {}, null, false, fallbackName, true)
  })
